import Vue from 'vue'
import { MutationTree } from 'vuex'
import { RootState, Discount } from './types'
import store from '.'
import { PaymentStateObjectMap } from '@/store/types'
import { Discount as PbDiscount } from 'proto/eshop/Basket_pb'

// TODO: перевести стор на классы (vuex-class-component)

type ProductMutationPayload = {
	id: string,
	count: number
}

export const mutations: MutationTree<RootState> = {
	addProduct: (state, { product: newProduct, count }) => {
		// удаляем из корзины все продукты других типов
		state.products = state.products.filter((p) => p.type === newProduct.type)
		// добавляем новый
		const product = state.products.find(product => product.id === newProduct.id)
		if (product) {
			product.count = count || product.count + 1
		} else {
			newProduct.count = count || 1
			state.products.push(newProduct)
		}
	},
	// add only one product, remove others
	setProduct: (state, { product: newProduct, count }) => {
		state.products.length = 0
		newProduct.count = count || 1
		state.products.push(newProduct)
	},
	deleteProduct: (state, { id }: ProductMutationPayload) => {
		const product = state.products.find((p) => p.id === id)
		if (!product) return
		const index = state.products.indexOf(product)
		state.products.splice(index, 1)
	},
	setState: (state, status: keyof PaymentStateObjectMap) => {
		state.paymentStateValue = status
	},
	setProductCount: (state, { id, count }: ProductMutationPayload) => {
		const product = state.products.find(p => p.id === id)
		if (!product) return
		product.count = Math.max(count, 0)
	},
	decreaseProductCount: (state, { id, count }: ProductMutationPayload) => {
		const product = state.products.find(p => p.id === id)
		if (!product) return
		store.commit('setProductCount', { id, count: product.count - count })
		if (product.count < 1) store.commit('deleteProduct', { id })
	},

	updateUserInfo: (state, { key, value }) => {
		Vue.set(state.userInfo, key, value)
	},

	updateDiscount: (state, { key, value }) => {
		Vue.set(state.discount, key, value)
	},
	setDiscount: (state, discount: PbDiscount) => {
		let d = new Discount(discount)
		if (d.applicableTo(state.products)) {
			state.discount = d
		} else {
			console.log('promo code ' + d.code + ' is not applicable to products: ' + state.products.map((p) => p.id)) // eslint-disable-line
			state.discount = new Discount()
		}
	},
	deleteDiscount: (state) => {
		state.discount = new Discount()
	},
}
